module.exports = __webpack_public_path__ + "static/img/rules.ee908e29.png";